import React from 'react';

import {DialogProps, Grid} from '@mui/material';

import {Types} from '@wheeebo/polaris-api';

import VehicleGroupListCard from './vehicle/VehicleGroupListCard';
import VehicleProfileCard from './vehicle/VehicleProfileCard';
import DialogBase from './DialogBase';

interface Props extends DialogProps {
  vehicleId: Types.UUID;
  onMemberSelected: (memberId: Types.UUID) => void;
  onGroupSelected: (groupId: Types.UUID) => void;
  onClose: () => void;
}

const VehicleDialog = ({vehicleId, onMemberSelected, onGroupSelected, onClose, ...props}: Props): JSX.Element => {
  return (
    <DialogBase title="Vehicle" onClose={onClose} {...props}>
      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <VehicleProfileCard vehicleId={vehicleId} onMemberSelected={onMemberSelected} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <VehicleGroupListCard vehicleId={vehicleId} onGroupSelected={onGroupSelected} />
        </Grid>
      </Grid>
    </DialogBase>
  );
};

export default VehicleDialog;
